import NiceModal from '@ebay/nice-modal-react'

import AuditModalV2 from 'components/Modal/AuditModal/AuditModalV2'
import AuditConfirmationModal from 'components/Modal/AuditModal/AuditConfirmationModal/AuditConfirmationModal'
import ReferenceCheckModal from 'components/Modal/ReferenceCheckModal/ReferenceCheckModal'

export const registerModals = (): void => {
  NiceModal.register('audit-v2', AuditModalV2)
  NiceModal.register('audit-confirmation', AuditConfirmationModal)
  NiceModal.register('reference-check', ReferenceCheckModal)
}
